import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import TableView from '../../Components/TableView';

// const Wrapper = styled.div``;

const ReviewerTable = ({ data }) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'first_published_by__name',
      key: 'first_published_by__name',
      render: (value) => value || '-',
      align: 'center',
    },
    {
      title: 'Number of Digests',
      dataIndex: 'count',
      key: 'count',
      render: (value) => value || '-',
      align: 'center',
    },
  ];
  return (
    <>
      <TableView tableColumns={columns} data={data} />
    </>
  );
};

ReviewerTable.propTypes = {
  data: PropTypes.object,
};

export default ReviewerTable;
